import { Row, Col, Space } from "antd";
import { criterias } from "../../constants";
import Style from "./PasswordCriteria.module.scss";
import { useIntl } from "react-intl";
import { Text } from "react_reusable_components";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import variables from "../../themes/base/styles/variables";

const PasswordCriteriaStyle = {
  dot: {
    height: variables.dot,
    width: variables.dot,
    borderRadius: variables.radiusSm,
  },
  message: {
    fontSize: variables.fontSizeSmall,
    lineHeight: variables.lineHeightLarge,
    fontWeight: variables.fontWeightNormal,
  },
};

const PasswordCriteria = ({ password }) => {
  const intl = useIntl();
  return (
    <Row>
      <Col xs={24} lg={24} className={Style.mb1} style={{}}>
        <Text style={PasswordCriteriaStyle.message} type="secondary">
          {getLocalizedMessage(intl, "login.passwordRequirements")}
        </Text>
      </Col>
      {criterias.map((criteria) => (
        <Col
          key={criteria.message}
          xs={24}
          lg={12}
          className={Style.colSpacing}
        >
          <Space size={8}>
            <div
              style={{
                ...PasswordCriteriaStyle.dot,
                backgroundColor: criteria.pattern.test(password)
                  ? variables.successGreen
                  : variables.grey2,
              }}
            />
            <Text style={PasswordCriteriaStyle.message}>
              {criteria.message}
            </Text>
          </Space>
        </Col>
      ))}
    </Row>
  );
};

export default PasswordCriteria;
